<template>
  <el-drawer
    title="数据核对"
    :visible.sync="salaryVerificationVisible"
    direction="rtl"
    size="82%"
    @close="salaryVerificationVisibleClose"
  >
    <el-row style="margin-top: 15px">
      <el-form
        ref="searchForm"
        :model="searchForm"
        label-width="70px"
        size="small"
        v-enterToNext="true"
      >
        <el-col :lg="4" :md="12" :sm="12" :xs="24">
          <el-form-item label="关键字" prop="keyWord">
            <el-input
              @keyup.enter.native="GetSalaryComparisonInfoList"
              v-model="searchForm.keyWord"
              clearable
              placeholder="请输入关键字查询"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-form>
      <el-button
        size="small"
        style="margin-left: 15px"
        type="primary"
        plain
        @click="GetSalaryComparisonInfoList"
        icon="el-icon-search"
        >查询</el-button
      >
    </el-row>
    <div class="salaryVerification">
      <div class="old">
        <div class="title">原始工时表</div>
        <MyTable
          class="mytable"
          :tableData="oldTableData"
          :tableConfig="oldTableConfig"
          :height="tableHeight"
          :indexFlag="oldIndexFlag"
        >
          <template v-slot:index="slotData" v-if="oldIndexFlag">
            <span>
              {{ slotData.scope.$index + 1 }}
            </span>
          </template>

          <!-- <template
            v-for="item in oldTableConfig"
            v-slot:[item.slotName]="slotData"
          >
            <div :key="item.field" v-if="detail.calculateState == 2">
              {{ slotData.scope.row[item.field] }}
            </div>
            <el-input
              v-if="detail.calculateState != 2"
              :key="item.field"
              v-model="slotData.scope.row[item.field]"
              @change="slotData.scope.row.change = '1'"
            ></el-input>

          </template> -->
        </MyTable>
      </div>
      <div class="new">
        <div class="title">标准工资表</div>
        <MyTable
          class="mytable"
          :tableData="newTableData"
          :tableConfig="calculateState == 3 ? tableConfig : newTableConfig"
          :height="tableHeight"
          :indexFlag="newIndexFlag"
        >
          <template v-slot:index="slotData" v-if="newIndexFlag">
            <span>
              {{ slotData.scope.$index + 1 }}
            </span>
          </template>
        </MyTable>
      </div>
    </div>
    <div class="submit-bar">
      <el-button
        :loading="submitLoading"
        @click="
          () => {
            $emit('return');
          }
        "
        >退回重算</el-button
      >
      <el-button type="primary" :loading="submitLoading" @click="onSubmit"
        >确认数据</el-button
      >
    </div>
  </el-drawer>
</template>

<script>
import MyTable from "@/components/Table";
import { format } from "echarts";

export default {
  components: {
    MyTable,
  },
  props: {
    visible: Boolean,
    salaryId: String,
    calculateState: Number,
  },
  data() {
    return {
      submitLoading: false,
      salaryVerificationVisible: false,
      oldTableData: [],
      newTableData: [],
      oldTableConfig: [
        {
          field: "name",
          label: "姓名",
          align: "center",
          flag: true,
          minWidth: 100,
        },
        {
          field: "taskmaster",
          label: "工头",
          align: "center",
          flag: true,
          minWidth: 100,
        },
        {
          field: "unitPrice",
          label: "单价",
          align: "center",
          flag: true,
          minWidth: 100,
        },
        {
          field: "manHour",
          label: "工时",
          align: "center",
          flag: true,
          minWidth: 100,
        },
        {
          field: "salary",
          label: "应发工资",
          align: "center",
          flag: true,
          minWidth: 100,
        },
        {
          field: "practicalSalary",
          label: "实发工资",
          align: "center",
          flag: true,
          minWidth: 100,
        },
      ],
      tableConfig: [
        {
          field: "name",
          label: "姓名",
          align: "center",
          flag: true,
          minWidth: 100,
        },
        {
          field: "taskmaster",
          label: "工头",
          align: "center",
          flag: true,
          minWidth: 100,
        },
        {
          field: "unitPrice",
          label: "单价",
          align: "center",
          flag: true,
          minWidth: 100,
        },
        {
          field: "manHour",
          label: "工时",
          align: "center",
          flag: true,
          minWidth: 100,
        },
        {
          field: "salary",
          label: "应发工资",
          align: "center",
          flag: true,
          minWidth: 100,
        },
        {
          field: "netPayroll",
          label: "实发工资",
          align: "center",
          flag: true,
          minWidth: 100,
        },
      ],
      newTableConfig: [],
      loading: false,
      tableHeight: "70vh",
      oldIndexFlag: true,
      newIndexFlag: true,
      searchForm: {},
    };
  },
  mounted() {},
  methods: {
    onSubmit() {
      let sendData = new FormData();
      sendData.append("salaryId", this.salaryId);

      this.submitLoading = true;
      this.$api.salary.CheckSalatyInfo(sendData).then((res) => {
        if (res.code == 0) {
          this.$message.success("核对成功");
          this.submitLoading = false;
          this.salaryVerificationVisible = false;
          this.$emit("refresh");
          console.log(res);
        }
      });
    },
    GetSalaryComparisonInfoList() {
      this.loading = true;
      let sendData = {};
      sendData = {
        keyWord: this.searchForm.keyWord,
        salaryId: this.salaryId,
      };
      this.$api.salary.GetSalaryComparisonInfoList(sendData).then((res) => {
        this.loading = false;
        if (res.code == 0) {
          this.oldTableData = res.data.originaSalaryDetailList;
          this.newTableData = res.data.salaryDetailList;
        }
      });
    },
    salaryVerificationVisibleClose() {
      this.$emit("close");
    },
  },
  watch: {
    visible(val) {
      this.salaryVerificationVisible = val;
      if (val) {
        this.GetSalaryComparisonInfoList();
      }
    },
  },
};
</script>

<style lang="less" scoped>
.submit-bar {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 10px 0;
  background-color: #fff;
  text-align: center;
  border-top: 1px solid #ddd;
  padding-right: 20px;
  z-index: 999999;
  .el-button {
    padding: 8px 20px;
  }
}
.salaryVerification {
  width: 100%;
  display: flex;
  padding-bottom: 50px;
  justify-content: space-between;
  .old,
  .new {
    width: 50%;
    // height: 300px;
    padding: 20px;
    padding-top: 0;
    .title {
      font-size: 18px;
      text-align: center;
    }
  }
  .new {
    border-left: 1px solid #e4e7ed;
  }
}
</style>